import Vue from "vue";
import axios from 'axios';
import {url} from './location.js';
Vue.prototype.ajaxUrl = url;
Vue.prototype.axios=axios;
import Qs from 'qs';
import wx from 'weixin-js-sdk';
let Bus = new Vue({
	data() {
		return {
			goodShopListScrollTo:''	,
			red:"#FF4530",
			white:"#fff",
			black:"#292929",
			grey:"#ABABAB",
			green:"#4dd865",
			CDgrey:"#cdcdcd",
			CCgrey:"#cccccc",
			blue:"#3DA6F0",
			slowlogin:'',
		}
	},

	methods: {
		
	},
});
export default Bus;